import { conditionFormChecker, putField } from "../../../../utils/form";
import lodash from "lodash";
import { createFieldImage, createFieldAttachment, createFieldTemplateBuilder } from "../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../i18n";
import { createLoading } from "../../../../utils/loading";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { Divider, Button, Form } from "ant-design-vue";
import { defineAsyncComponent } from "vue";
import { openModalWebCamForm } from "../../../../components/input/template-builder/web-cam/modal-web-cam.logic";

export const { isLoading, setIsLoading } = createLoading();
export const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24, md: 12, style: { borderRight: "1px dotted gray !important" } }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        {
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}attachmentImageIdCardsLib.0`,
                            colProp: () => ({ xs: 24, md: 15 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
                            label: () => i18n.global.t("model.user.imageIdCards"),
                            formItemRender: ({ field }) => {
                                const label = field?.label?.();
                                const formItemProp = field?.formItemProp?.({ field });
                                return (
                                    <Form.Item label={label} {...formItemProp}>
                                        <Button
                                            size="large"
                                            onClick={() => {
                                                openModalWebCamForm({
                                                    data,
                                                    onWebCam: ({ fileModel }) => {
                                                        fileModel.group = "IdCard";
                                                        fileModel.name = "idCard.png";
                                                        fileModel.documentName = "idCard";
                                                        fileModel.isSave = true;
                                                        lodash.set(modelRef.attachmentIdCards, 0, fileModel);
                                                    },
                                                });
                                            }}
                                        >
                                            <CIcon file="camera.svg"></CIcon>
                                        </Button>
                                    </Form.Item>
                                );
                            },
                        },
                        createFieldImage({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}attachmentImageIdCards.0`,
                            colProp: () => ({ xs: 24, md: 15 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
                            label: () => i18n.global.t("model.user.imageIdCards"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value:
                                            model.attachmentIdCards?.[0]?.url || model.attachmentIdCards?.[0]?.blob
                                                ? model.attachmentIdCards?.[0]
                                                : null,
                                        "onUpdate:value": (value) => {
                                            if (!model.attachmentIdCards?.[0]) {
                                                model.attachmentIdCards.push({});
                                            }
                                            const refAttach = model.attachmentIdCards?.[0];
                                            refAttach.name = value?.name;
                                            refAttach.documentName = refAttach.documentName ? refAttach.documentName : value?.name;
                                            refAttach.blob = value?.blob;
                                            refAttach.isSave = value?.isSave;
                                            refAttach.size = value?.size;
                                            refAttach.type = value?.type;
                                            refAttach.group = value?.group;
                                        },
                                        group: "IdCard",
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]}),
                }),
            }),
            {
                key: `${prefix}dividerAttachment.0`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24, md: 2, align: "center" }),
                formItemRender: () => <Divider dashed={true} orientation={"center"} type={"vertical"} style={{ height: "100%" }}></Divider>,
            },
            createFieldAttachment({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attachmentIdCards.0`,
                colProp: () => ({ xs: 24, md: 5 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("button.upload"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.attachmentIdCards?.[0]?.url || model.attachmentIdCards?.[0]?.blob ? model.attachmentIdCards?.[0] : null,
                            "onUpdate:value": (value) => {
                                if (!model.attachmentIdCards?.[0]) {
                                    model.attachmentIdCards.push({});
                                }
                                const refAttach = model.attachmentIdCards?.[0];
                                refAttach.name = value?.name;
                                refAttach.documentName = refAttach.documentName ? refAttach.documentName : value?.name;
                                refAttach.blob = value?.blob;
                                refAttach.isSave = value?.isSave;
                                refAttach.size = value?.size;
                                refAttach.type = value?.type;
                                refAttach.group = value?.group;
                            },
                            group: "IdCard",
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    );
                },
            }),
        ],
    });
};

export const initForm = ({ props, data, refs }) => {
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
};
